import { ErrorMessage, Formik } from "formik";
import React, { useEffect } from "react";
import { Form, Label, Card } from "semantic-ui-react";
import * as Yup from "yup";

import { useVttSubBiome } from "../../../providers/VttSubBiomeProvider";
import { useState } from "react";
import { VttSubBiome } from "../../../models/vtt-models/VttBiome";
import EsvdInputInline from "../../../shared/InputInline";
import { ErrorHandler } from "../../../shared/ExceptionHandling";
import { ViewHandles, useVtt } from "../../../providers/VttProvider";

const defaultBiome: VttSubBiome = { name: "" };

const VttSubBiomeEntry = () => {
	const { currentView, setCurrentView } = useVtt();
	const { createVttSubBiome, getVttSubBiome, updateVttSubBiome } =
		useVttSubBiome();
	const [vttSubBiome, setVttSubBiome] = useState<VttSubBiome>();

	useEffect(() => {
		const { subbiomeid } = currentView;
		if (subbiomeid) {
			//retrieve biome
			(async () => {
				const vt = await getVttSubBiome(subbiomeid);
				setVttSubBiome(vt);
			})();
		} else {
			//set to default
			setVttSubBiome(defaultBiome);
		}
	}, []);

	const handleFormSubmit: Function = async (
		values: any,
		setErrors: Function
	) => {
		try {
			if (values.id) {
				await updateVttSubBiome(values);
			} else {
				await createVttSubBiome(values);
			}
			setCurrentView({ view: ViewHandles.subbiome });
		} catch (error) {
			// setErrors(error);
			setErrors({ error: ErrorHandler(error) });
			// console.log(error);
		}
	};

	return (
		<Card.Content>
			<Formik
				enableReinitialize={true}
				validationSchema={validationSchema}
				initialValues={vttSubBiome || defaultBiome}
				onSubmit={(values, { setErrors }) => {
					handleFormSubmit(values, setErrors);
				}}>
				{({
					values,
					handleChange,
					handleSubmit,
					isValid,
					isSubmitting,
					dirty,
					errors,
					resetForm,
					setFieldValue,
				}) => (
					<Form
						className="custom-ui-element"
						onSubmit={handleSubmit}
						autoComplete={"off"}
						encType="multipart/form-data">
						<div style={{ display: "none" }}>
							<EsvdInputInline name="id" type="hidden" />
						</div>
						<EsvdInputInline
							name="name"
							label="Name (*)"
							fluid
							placeholder="Name"
						/>
						<ErrorMessage
							name="error"
							render={() => (
								<Label
									style={{ marginBottom: 5, borderColor: "none" }}
									basic
									color="red"
									size="tiny"
									content={errors.error}
								/>
							)}
						/>
						<label
							style={{
								color: "red",
							}}>{`(*) = required`}</label>
						<br />
						<button
							className="ui button btn btn-primary"
							type="reset"
							style={{
								marginTop: "1rem",
								backgroundColor: "#70bbfd",
								display: "block !important",
								height: "2rem",
								width: "5rem",
							}}
							onClick={() => {
								setCurrentView({ view: ViewHandles.subbiome });
							}}>
							Back
						</button>
						<button
							className="ui button btn btn-primary right floated"
							type="submit"
							style={{
								marginTop: "1rem",
								backgroundColor: "#70bbfd",
								display: "block !important",
								height: "2rem",
								width: "5rem",
							}}>
							Save
						</button>
					</Form>
				)}
			</Formik>
		</Card.Content>
	);
};

const validationSchema: any = Yup.object({
	name: Yup.string().trim().required("Name is required"),
});

export default VttSubBiomeEntry;
